<script>
import { renotificationState } from '@/utils/faqRenotification'

const LABELS = {
  never: 'Renotifier la question',
  available: 'Renotifier de nouveau la question',
  blocked: 'Renotification indisponible'
}

export default {
  computed: {
    state () {
      return renotificationState(this.params.data)
    },
    isBlocked () {
      return this.state.status === 'blocked'
    },
    ariaLabel () {
      return LABELS[this.state.status]
    }
  },
  methods: {
    handleClick () {
      if (this.isBlocked || typeof this.params.onClick !== 'function') return
      this.params.onClick(this.params.data)
    }
  }
}
</script>

<template>
  <div class="renotification-cell">
    <!-- aria-disabled rather than disabled: a disabled button swallows the hover that opens the grid tooltip. -->
    <button
      type="button"
      class="renotification-cell__button"
      :class="`renotification-cell__button--${state.status}`"
      :aria-label="ariaLabel"
      :aria-disabled="isBlocked ? 'true' : 'false'"
      @click.stop="handleClick"
      @dblclick.stop
    >
      <i class="fas fa-bell" aria-hidden="true"></i>
    </button>
  </div>
</template>

<style lang="scss" scoped>
.renotification-cell { align-items: center; display: flex; height: 100%; justify-content: center; }
.renotification-cell__button { background: transparent; border: 0; cursor: pointer; font-size: 15px; line-height: 1; padding: 4px; }
.renotification-cell__button--never { color: #2563eb; }
.renotification-cell__button--available { color: #22c55e; }
.renotification-cell__button--blocked { color: #9ca3af; cursor: not-allowed; }
</style>
